export default "__VITE_ASSET__C$MrGsnU__"